<template>
    <div>
      <div class="action-buttons ">
        <div class="left-buttons mar-rt-10">
          <div class="col-md-12" style="margin-top: 15px;">
            <div class="form-group" v-if="groupedLocations">
              <label>{{ $t('gestiune.locatie') }}</label>
              <select class="form-control" v-model="selectedLocation" :disabled="loading">
                <optgroup
                  v-for="group in groupedLocations"
                  :key="group.vat"
                  :label="`VAT: ${group.vat}`"
                >
                  <option
                    v-for="loc in group.locations"
                    :key="loc.id"
                    :value="loc"
                  >
                    {{ loc.name }}
                  </option>
                </optgroup>
              </select>
            </div>
          </div>
          <div class="col-md-12" style="margin-top: 15px;">
            <div class="form-group">
              <label>{{ $t('gestiune.gestiune') }}</label>
              <el-select
                  v-model="selectedGestiune"
                  placeholder="Selectează gestiunea"
                  :disabled="loading"
                >
                <el-option
                  v-for="gestiune in filteredGestiuni"
                  :key="gestiune.id"
                  :label="gestiune.name"
                  :value="gestiune.id"
                ></el-option>
              </el-select>
            </div>
          </div>
         </div>
         <div class="right-buttons">
         </div>
      </div>
      <div class="card mar-to-15 tableInvoice">
          <div class="card-content">
            <div :class="(loading ? 'show-loader' : 'hide-loader')">
              <div class="el-loading-spinner">
                <svg viewBox="25 25 50 50" class="circular">
                  <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
                </svg><!---->
              </div>
            </div>
            <div class="tableInvoice" style="overflow-x: auto;">
              <el-table :data="tableData">
                <el-table-column prop="codProdus" label="PROD CODE" min-width="150"></el-table-column>
                <el-table-column prop="numeProdus" label="PROD NAME" min-width="250"></el-table-column>

                <el-table-column prop="totalVanzari" label="TOT SALES" min-width="150"></el-table-column>
                <el-table-column prop="vanzariLocatie" label="LOC SALES" min-width="150"></el-table-column>
                <el-table-column prop="vanzariPachet" label="PKG SALES" min-width="150"></el-table-column>
                <el-table-column prop="alteMetode" label="OTH SALES" min-width="180"></el-table-column>

                <el-table-column prop="pierderiProduse" label="FIN WASTE" min-width="180"></el-table-column>
                <el-table-column prop="pauzaMasa" label="MEAL" min-width="180"></el-table-column>

                <el-table-column prop="produseAnulate" label="CNL RCPT" min-width="200"></el-table-column>
                <el-table-column prop="totalVanzari" label="TOT SALES" min-width="200"></el-table-column>

                <el-table-column prop="pretProdus" label="PRICE/PROD" min-width="150"></el-table-column>
                <el-table-column prop="bani" label="MONEY" min-width="150"></el-table-column>
              </el-table>
            </div>
           </div>
      </div>
    </div>
</template>

<script>
// import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
// import swal from 'sweetalert2'

export default {
   // components: {
  //   GeneralTopBar
  // },
  data () {
    return {
      loading: false,
      tableData: [
        {
          codProdus: 'CF001',
          numeProdus: 'Cafea Boabe 1kg',
          totalVanzari: 120,
          vanzariLocatie: 80,
          vanzariPachet: 30,
          alteMetode: 10,
          pierderiProduse: 2,
          pauzaMasa: 1,
          produseAnulate: 3,
          pretProdus: 25,
          bani: 3000
        },
        {
          codProdus: 'LP002',
          numeProdus: 'Lapte 1L',
          totalVanzari: 200,
          vanzariLocatie: 150,
          vanzariPachet: 40,
          alteMetode: 10,
          pierderiProduse: 5,
          pauzaMasa: 2,
          produseAnulate: 1,
          pretProdus: 5,
          bani: 1000
        },
        {
          codProdus: 'CH003',
          numeProdus: 'Cheesecake Slice',
          totalVanzari: 75,
          vanzariLocatie: 50,
          vanzariPachet: 20,
          alteMetode: 5,
          pierderiProduse: 1,
          pauzaMasa: 0,
          produseAnulate: 2,
          pretProdus: 15,
          bani: 1125
        }
      ],
      selectedGestiune: null,
      selectedLocation: null
    }
  },
  props: {
    gestiuneOptions: {
      type: Array,
      required: true
    },
    groupedLocations: {
      type: Array,
      required: true
    }
  },
  computed: {
    filteredGestiuni () {
      if (!this.selectedLocation) return []
      const result = this.gestiuneOptions.filter(
        (g) => g.externalLocationId === this.selectedLocation.true_id
      )
      return result
    }
  },
  watch: {
    selectedLocation (newLocation) {
      this.resetTable()

      this.selectedGestiune = null
      this.selectedProduct = null
      this.tableData = []
      if (this.filteredGestiuni && this.filteredGestiuni.length) {
        this.selectedGestiune = this.filteredGestiuni[0].id
      }
      this.selectedVatNumber = newLocation.inv_fiscal_code
    }
  },
  created () {
    this.companyID = this.$session.get('selectedCompany')
  },
  mounted () {
    this.firstLoad()
  },
  methods: {
    firstLoad () {
      if (this.groupedLocations && this.groupedLocations.length) {
        this.selectedLocation = this.groupedLocations[0].locations[0]
      }
    }
  }
}
</script>

<style scoped>
.tableInvoice .el-table .cell {
  height: 90px;
}
.action-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center; /* Aliniază butoanele pe axa verticală */
  margin-bottom: 15px;
}

.left-buttons {
  display: flex;
}

.disabled {
  pointer-events: none;
  opacity: 0.5;
}

.left-buttons button{
  display: flex;
  align-items: center;
  padding-top: 10px;
}

.left-buttons el-button {
  margin-right: 10px; /* Spațiere între butoane */
}

.right-button {
  margin-left: auto; /* Asigură că butonul "Editare Multipla" se aliniază la dreapta */
}

.button-group {
  display: flex; /* Folosește flexbox pentru alinierea orizontală */
  justify-content: flex-end; /* Aliniază butoanele la dreapta */
}
.button-group .btn {
    margin-right: 10px; /* Adaugă un spațiu între butoane */
}
.button-group .btn:last-child {
    margin-right: 0; /* Elimină marginea dreaptă pentru ultimul buton */
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/Reports/ProductMixReport.vue